import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  InterventionBookingSearchRequest,
  OpenItemListData,
  OpenItemListPrintRequest,
  OpenItemListPrintResponse,
  OpenItemListSearchRequest
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/open-item-list`;

export const searchOpenItemList = (
    openItemListSearchRequest: OpenItemListSearchRequest,
    source: CancelTokenSource): Promise<OpenItemListData> => {
  return axios
      .post(`${apiUri}/search`, openItemListSearchRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const getOpenItemListPrintPreview = (openItemListPrintRequest: Partial<OpenItemListPrintRequest>,
                                           source: CancelTokenSource): Promise<OpenItemListPrintResponse> => {
  return axios
      .post(`${apiUri}/output`, openItemListPrintRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const getOpenItemListPdfUrl = (openItemListPdfId: string, openItemListPdfName: string) => {
  return `${baseUrl}/bbfb74ce81f64e29b8bc30333f52dd8a/${openItemListPdfId}/${openItemListPdfName}`;
};

export const exportOpenItemList = (
    request: Partial<OpenItemListPrintRequest>,
    source: CancelTokenSource): Promise<any> => {

  return axios
      .post(`${apiUri}/export`, request, {cancelToken: source.token})
      .then(response => {
        const type = response.headers['content-type'];
        // @ts-ignore
        const BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);
        const blob = new Blob([BOM, response.data], {type: type});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = response.headers['content-disposition'];
        const filenameRegex = /filename=(.*)/;
        const regexResponse = filenameRegex.exec(link.download);
        const defaultFileName = "response.csv";
        const fileName = regexResponse ?
            regexResponse[1] ? regexResponse[1] : defaultFileName :
            defaultFileName;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        return true;
      });
};
